import { useState } from "react";
import { Select, InputStyledDiv, Close, Info, OptionProps } from "components";
import { FilterItem, TableFilter, TableHeading, TableOptions } from "components/Table";
import { isMasterAdmin, STATUSES } from "helpers";
import { SearchableSelect } from "components/forms/SearchableSelect";
import { twMerge } from "tailwind-merge";
import { useUserManagementContext } from "../utils";
import { t } from "i18next";
import { useGetCitiesQuery } from "services/cityApi";

export const UserTableHeadings = () => {
  const { user, params, onResetFilters, onSort, onFilterByStatus, onChangeCity } = useUserManagementContext();
  const { data: citiesResponse, isLoading, isError } = useGetCitiesQuery({ lang: "MK" });
  const cities = citiesResponse?.data || [];

  const [showInfo, setShowInfo] = useState(false);

  const resetFilters = (
    <div className="absolute -mt-1.5 flex flex-col">
      {showInfo && (
        <InputStyledDiv className="absolute -mt-4 ml-6 w-max bg-primary/5 p-0 text-xs font-thin">
          {t("userManagement.clearAllFilters")}
        </InputStyledDiv>
      )}
      <div onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)} className="relative">
        <Info width={7} height={7} className="ml-4" />
      </div>
      <Close className="text-error-text" onClick={onResetFilters} />
    </div>
  );

  const cityOptions = (() => {
    const allCities =
      cities.map((city) => ({
        value: city.id,
        label: city.city || `City ${city.id}`,
        disabled: false,
      })) || [];

    return [
      {
        value: "",
        label: t("userManagement.filterByCity"),
      },
      ...allCities,
    ];
  })();

  const headings: Array<JSX.Element | string> = [
    <>
      {resetFilters}
      <TableHeading
        onClick={(order) => {
          onSort("full_name", order);
        }}
        order={params.sort === "full_name" ? params.order : undefined}
      >
        {t("table.headers.fullName")}
      </TableHeading>
    </>,
    isLoading ? (
      <div>{t("userManagement.loadingCities")}</div>
    ) : isError ? (
      <div>{t("userManagement.loadingCitiesError")}</div>
    ) : (
      <SearchableSelect
        options={cityOptions}
        placeholder={t("userManagement.filterByCity")}
        onChange={onChangeCity}
        value={params.city_id || ""}
        disabled={isLoading}
      />
    ),

    <TableHeading
      onClick={(order) => {
        onSort("phone_number", order);
      }}
      order={params.sort === "phone_number" ? params.order : undefined}
    >
      {t("table.headers.phoneAndEmail")}
    </TableHeading>,
    <TableHeading
      onClick={(order) => {
        onSort("last_sign_in", order);
      }}
      order={params.sort === "last_sign_in" ? params.order : undefined}
    >
      {t("table.headers.lastSignIn")}
    </TableHeading>,
    <TableFilter
      onFilter={onFilterByStatus}
      values={STATUSES}
      label={t("table.headers.status")}
      selectedFilter={typeof params.status !== "undefined" ? (Number(params.status) as FilterItem) : undefined}
    />,
    <TableHeading
      onClick={(order) => {
        console.log("");
      }}
      order={params.sort === "last_sign_in" ? params.order : undefined}
    >
      {t("table.headers.loggedIn")}
    </TableHeading>,
    <TableHeading onClick={() => console.log("dummy")}>{t("table.headers.credits")}</TableHeading>,
    <TableOptions>{t("table.headers.options")}</TableOptions>,
  ];

  return (
    <>
      {headings.map((heading, index) => {
        const isLast = index === headings.length - 1;

        return (
          <th
            key={index}
            scope="col"
            className={twMerge(
              "h-[100px] max-h-[100px] w-[200px] min-w-[200px] break-words bg-white py-4 text-sm font-semibold text-primary",
              isLast && "shadow-left sticky right-0 z-10"
            )}
          >
            {heading}
          </th>
        );
      })}
    </>
  );
};
